import { useMemo } from 'react';
import { api as axiosInstance } from 'communication/httpClient';

export const useInterceptor = (errorResponseHandler) => {
  return useMemo(() => {
    axiosInstance.interceptors.response.use((response) => response, errorResponseHandler);
  }, [errorResponseHandler]);
};
